<template>
  <tr>
    <td>{{ refinementName }}</td>
    <td>
      <span class="text-primary cursor--pointer" @click="show">
        <i class="fa fa-info-circle"></i> {{ (inEnglish) ? printArticle.article.name_en : printArticle.article.name }}
      </span>
    </td>
    <td v-if="configuration.upload.file_exists">
      <span v-if="cloud.status < PRINT_CLOUD_STATUS_FINISHED"
        class="text-primary cursor--pointer"
        @click="download">
        <i class="fa fa-download"></i> {{ configuration.upload.original_name }}
      </span>
      <span v-else class="text-primary">{{ configuration.upload.original_name }}</span>
    </td>
    <td v-else>
      <span class="text-primary">{{ configuration.upload.original_name }}</span><br>
      <span class="mr-2 bg-danger">
        <i class="fa fa-warning text-danger"></i> {{ $t('configurator.labels.file_missing') }}
      </span>
    </td>
  </tr>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { downloadFile } from '@/utils/file'

const store = useMainStore()
// define props
const props = defineProps({
  configuration: {
    type: Object,
    required: true
  },
  article: {
    type: Object,
    required: true
  },
})
// define emits
const emit = defineEmits(['show'])
// define computed props
const locale = computed(() => store.settings.locale)
const cloud = computed(() => store.tmp.cloud)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const printArticle = computed(() => {
  return props.article.prints.find((printArticle) => {
    return printArticle.configurations
      .map((config) => config.request_article_id)
      .includes(props.configuration.request_article_id)
  })
})

const refinementName = computed(() => {
  return (inEnglish.value)
    ? printArticle.value.article_print.name_en
    : printArticle.value.article_print.name
})
// define methods
const show = () => {
  emit('show', printArticle.value)
}

const download = async () => {
  await downloadFile(
    '/print/' + cloud.value.uuid + '/download/' + props.configuration.upload.id,
    props.configuration.upload.original_name
  )
}
</script>